import React from "react";
import { Redirect, Route } from "react-router-dom";
import { localStorageService } from "../_services/localStorage.service";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return localStorageService.isAuth() ? (
          <section className={`content`}>
            <Component {...props} {...rest} />
          </section>
        ) : (
          <Redirect to="/login" />
        );
      }}
    />
  );
};
